import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';

const defaultFaqs = [
  { q: "What is a trademark and why do I need one?", a: "A trademark USA registration is a legal protection for your brand name, logo, or slogan. It gives you exclusive rights through USPTO trademark registration to use your mark in commerce across the United States. This helps protect your business identity and prevents others from copying or using similar marks." },
  { q: "How long does the trademark registration process take?", a: "The USA trademark registration process typically takes several months depending on USPTO review, examination, and approval. With proper trademark filing services, the process becomes smoother, more accurate, and less likely to face delays or objections." },
  { q: "What is the difference between TM and ® symbol?", a: "The TM symbol is used for an unregistered trademark, while the ® symbol is only allowed after official federal trademark registration with USPTO. The ® symbol provides full legal protection under USA trademark law." },
  { q: "Can I trademark a name that is already in use?", a: "You can only register a trademark if it is not already registered or too similar to an existing one. A proper trademark search and clearance is important before starting your trademark application USA to avoid rejection or legal issues." },
  { q: "What happens if my trademark application is rejected?", a: "If your USPTO trademark application is rejected, you may receive an office action requiring corrections or legal clarification. Our trademark registration experts help resolve issues and improve approval chances through proper filing and response strategy." },
  { q: "Do I need a trademark for my small business?", a: "Yes, even small businesses benefit from USA trademark registration because it protects your brand name, logo, and identity. It builds trust, prevents infringement, and gives your business strong legal protection for future growth." }
];

export default function FAQSection({ faqs = defaultFaqs, title = "Frequently Asked Questions", label }) {
  return (
    <section data-testid="faq-section" className="py-20 md:py-32 bg-[#0D1729]">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="text-left mb-8">
              <p className="uppercase text-xs tracking-[0.2em] font-bold text-[#D4AF37] mb-4 font-['Outfit']">{label || "FAQ"}</p>
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white font-['Outfit'] tracking-tight">
                {title}
              </h2>
            </div>
            <Accordion type="single" collapsible className="space-y-3">
              {faqs.map((faq, i) => (
                <AccordionItem
                  key={i}
                  value={`faq-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="bg-[#121E3D] border border-[#1D2D50] rounded-sm overflow-hidden"
                >
                  <AccordionTrigger className="px-6 py-4 text-left text-white hover:text-[#D4AF37] text-sm font-medium font-['Outfit'] hover:no-underline [&[data-state=open]]:text-[#D4AF37]">
                    {faq.q}
                  </AccordionTrigger>
                  <AccordionContent className="px-6 pb-4 text-[#A0AABF] text-sm leading-relaxed">
                    {faq.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
          <div className="relative">
            <img
              src="/assets/img/main-faq.webp"
              alt="FAQ"
              className="w-full h-auto rounded-sm shadow-2xl object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
